import { map } from 'lodash';

class DiscountPeriodFormController {
  constructor($rootScope, $scope, $state, discountService, messageService) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
  }

  $onInit() {
    if ( this.discount.periods.length > 0 ) {
      for ( let period of this.discount.periods ) {
        period.start = (period.start)? moment(period.start, 'YYYY-MM-DD') : '';
        period.end = (period.end)? moment(period.end, 'YYYY-MM-DD') : '';
      }
    } else {
      this.discount.periods = [{start: ''}];
    }
  }

  onSave() {
    for ( let period of this.discount.periods ) {
      if ( period.start ) {
        period.start = period.start.format('YYYY-MM-DD');
      }
      if ( period.end && typeof period.end !== 'boolean') {
        period.end = period.end.format('YYYY-MM-DD');
      }
    }

    return this.discountService.savePeriods(this.discount.periods, this.discount.id)
      .then(response => {
        if (!this.discount.events) {
          this.messageService.success(`The discount <strong>${this.discount.code}</strong> was successfully updated!`);
          this.$state.go('app.admin.discount-edit', {discount: this.discount.id, tab: 'events'});
        } else {
          this.messageService.success(`The discount <strong>${response.code}</strong> was successfully updated.`, [`app.admin.discount-edit({ 'discount' : ${this.discount.id}})`, `Discount`]);
          this.$state.go('app.admin.discounts');
        }
      })
      .catch((error) => {
        this.messageService.failure(`The discount <strong>${this.discount.code}</strong> could not be successfully created: ${error.statusText}`);
        this.messageService.push();
          var sourceElement = Object.keys(error.data)[0];
          if ( sourceElement > 0 ) {
            this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
          } else {
            this.$scope.$ctrl.form.$setValidity(sourceElement, false);
          }
      });
  }

  clearDate(model) {
    model = undefined;
  }
}

DiscountPeriodFormController.$inject = [ '$rootScope', '$scope', '$state', 'discountService', 'messageService' ];

export default DiscountPeriodFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/controllers/discount.period.form.controller.js